import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { getEmailTemplates } from "../Redux/Reducers/ProductSlice";
import { getPaginationTotal, getRowsPerPageOptions } from "../helper/tablePagination";

const EmailTemplatesList = ({ onEdit }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const { emailTemplates, loading, error, emailTemplatesPagination } = useSelector((state) => state.products);

  useEffect(() => {
    dispatch(getEmailTemplates({ page: page + 1, perPage: rowsPerPage }));
  }, [dispatch, page, rowsPerPage]);

  const columns = [
    {
      name: "name",
      label: "Template Name",
      options: {
        customBodyRender: (value) => (
          <div className="d-flex flex-column">
            <span className="fw-medium">{value || "-"}</span>
          </div>
        ),
      },
    },
    // {
    //   name: "subject",
    //   label: "Subject",
    //   options: {
    //     customBodyRender: (value) => (
    //       <p className="col-description mb-0">{value || "-"}</p>
    //     ),
    //   },
    // },
    {
      name: "active",
      label: "Status",
      options: {
        customBodyRender: (value) => (
          <span className={`badge ${value === false ? "bg-secondary" : "bg-success"}`}>
            {value === false ? "Inactive" : "Active"}
          </span>
        ),
      },
    },
    {
      name: "Manage",
      label: "Manage",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const rowData = emailTemplates[dataIndex];

          return (
            <div className="d-flex justify-content-center">
              <Icon
                onClick={() => rowData?.key && onEdit(rowData)}
                className={`editBtn ${!rowData?.key ? "opacity-50" : ""}`}
                icon="line-md:edit"
                width="24"
                height="24"
                style={{ cursor: rowData?.key ? "pointer" : "not-allowed" }}
              />
            </div>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    rowsPerPage,
    rowsPerPageOptions: getRowsPerPageOptions(
      getPaginationTotal(emailTemplatesPagination, emailTemplates.length)
    ),
    responsive: "standard",
    elevation: 0,
    print: false,
    download: false,
    viewColumns: false,
    filter: false,
    search: false,
    page,
    onChangePage: (newPage) => {
      setPage(newPage);
    },
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
      setPage(0);
    },
  };

  if (loading && emailTemplates.length === 0) {
    return (
      <div className="card basic-data-table">
        <div className="card-body text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 mb-0">Loading email templates...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card basic-data-table">
        <div className="card-body text-center py-5">
          <div className="text-danger">
            <Icon icon="material-symbols:error-outline" width="48" height="48" />
            <p className="mt-3">
              Error: {typeof error === "string" ? error : "Failed to load email templates"}
            </p>
            <button
              className="btn btn-primary mt-3"
              onClick={() => dispatch(getEmailTemplates({ page: page + 1, perPage: rowsPerPage }))}
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card basic-data-table email-templates-table">
      <div className="card-body">
        <MUIDataTable
          data={emailTemplates}
          columns={columns}
          options={options}
          className="overflow-hidden packageTable"
        />
      </div>
    </div>
  );
};

export default EmailTemplatesList;
